import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-7db585ca.js';
import * as emberService from '@ember/service';
import Helper from '@ember/component/helper';
import handleQueryParams from '../utils/handle-query-params.js';

var _class, _descriptor;
const service = emberService.service ?? emberService.inject;
let UrlForHelper = (_class = class UrlForHelper extends Helper {
  constructor(...args) {
    super(...args);

    _initializerDefineProperty(this, "router", _descriptor, this);
  }

  compute(_params) {
    let params = handleQueryParams(_params);
    return this.router.urlFor(...params);
  }

}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "router", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);

export { UrlForHelper as default };
